<template>
  <div>
    <v-dialog v-model="dialog.form" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 text-first blue-grey lighten-5 py-5">
          Status Pembangunan
        </v-card-title>
        <v-card-title>
          <ValidationObserver ref="observer" style="width: 100%;">
            <v-form>
              <ValidationProvider name="Status Pembangunan" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Status Pembangunan"
                  :color="style.primary"
                  prepend-inner-icon="mdi-home-outline"
                  v-model="form.status"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <!-- <ValidationProvider name="Persentase" rules="required" v-slot="{ errors }">
                <v-text-field
                  type="number"
                  dense
                  outlined
                  label="Persentase"
                  color="#4FC3F7"
                  prepend-inner-icon="mdi-home-thermometer-outline"
                  append-icon="mdi-percent-outline"
                  v-model="form.persen"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider> -->
              <div class="d-flex align-center">
                <p class="caption text-second mb-0">
                  Progres Bangunan (bisa dikosongi)
                </p>
                <v-spacer/>
                <image-input v-model="images">
                  <div slot="activator" class="d-flex align-center">
                    <v-btn
                      outlined
                      x-small
                      width="100"
                      color="green"
                      class="text-capitalize">
                      Tambah
                    </v-btn>
                  </div>
                </image-input>
                <v-btn
                  v-if="form.files.length > 0"
                  outlined
                  x-small
                  width="100"
                  color="red"
                  class="text-capitalize ml-2"
                  @click="form.files = []">
                  Hapus Semua
                </v-btn>
              </div>
              <v-divider class="my-1 mb-2"/>
              <v-slide-group
                prev-icon="mdi-chevron-left-circle"
                next-icon="mdi-chevron-right-circle"
                center-active
                show-arrows>
                <v-slide-item
                  v-for="(item, index) in form.files"
                  :key="index"
                  v-slot:default="{ active, toggle }">
                  <v-card
                    class="mx-2 box-shadow"
                    width="150"
                    height="150" 
                    outlined
                    @click="toggle">
                    <v-img
                      width="150"
                      height="150" 
                      :src="item"
                      gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.5)">
                      <v-icon color="white" style="position: absolute; top: 5px; right: 5px;" @click="remove(index)">mdi-close-circle</v-icon>
                    </v-img>
                  </v-card>
                </v-slide-item>
              </v-slide-group>
            </v-form>
          </ValidationObserver>
        </v-card-title>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions class="py-5 px-6">
          <v-spacer/>
          <v-btn
            outlined
            :color="style.primary"
            class="text-capitalize green--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn 
            outlined 
            color="red"
            class="text-capitalize red--text"
            :disabled="process.form"
            @click="reset(); $refs.observer.reset();">
            <v-icon small class="mr-1">mdi-close-circle</v-icon>
            Batalkan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.success"
      width="300">
      <v-card 
        class="border-radius">
        <div class="pa-5">
          <div class="d-flex align-center">
            <v-divider color="white"></v-divider>
            <div class="mx-1 font-weight-bold text-second">BERHASIL</div>
            <v-divider color="white"></v-divider>
          </div>
          <div class="d-flex justify-center my-3">
            <div class="sa">
              <div class="sa-success">
                <div class="sa-success-tip"></div>
                <div class="sa-success-long"></div>
                <div class="sa-success-placeholder"></div>
                <div class="sa-success-fix"></div>
              </div>
            </div>
          </div>
          <div class="text-center caption text-second line-text-first mb-8">
            Ubah progres pembangunan tersimpan.
          </div>
        </div>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="12" class="py-0">
        <v-card
          style="border-radius: 0px;"
          flat>
          <div style="background: var(--color-primary)">
            <v-card-title class="subtitle-2 white--text">
              Pembangunan
            </v-card-title>
            <v-card-subtitle class="white--text line-text-first pt-2 d-flex align-center caption">
              Anda bisa mengubah proses pembangunan unit, dengan menggeser kanan atau kiri atau menekan tombol
              minus (<v-icon x-small color="white">mdi-home-minus</v-icon>)
              atau
              plus (<v-icon x-small color="white">mdi-home-plus</v-icon>)
            </v-card-subtitle>
          </div>
          <v-card-text class="caption text-second">
            Proses
            <v-row>
              <v-col cols="12" md="5" class="d-flex align-center">
                <v-icon class="cursor-pointer" :disabled="form.progres < 1 || (!user.user_company_roles_name.includes('superuser') && !user.user_company_roles_name.includes('teknik') && !user.user_company_roles_name.includes('developer'))" @click="form.progres = form.progres-5">mdi-home-minus</v-icon>
                <v-progress-linear
                  v-model="form.progres"
                  :color="form.progres <= 25 ? 'red' : form.progres <= 75 ? 'orange' : 'teal'"
                  class="border-radius white--text cursor-pointer mx-2"
                  disabled
                  height="20">
                  <strong>{{ Math.ceil(form.progres) }}%</strong>
                </v-progress-linear>
                <v-icon class="cursor-pointer" :disabled="form.progres >= 100 || (!user.user_company_roles_name.includes('superuser') && !user.user_company_roles_name.includes('teknik') && !user.user_company_roles_name.includes('developer'))" @click="form.progres = form.progres+5">mdi-home-plus</v-icon>
              </v-col>
              <v-col cols="12" md="7" class="text-right">
                <!-- JIKA MASIH AKTIF -->
                <div v-if="booking.company_project_is_active === '1'">
                  <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('teknik') || user.user_company_roles_name.includes('developer')"
                    outlined
                    small
                    color="orange"
                    class="text-capitalize mr-2"
                    :disabled="process.form"
                    @click="progress">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    Ubah Progres
                  </v-btn>
                  <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('teknik') || user.user_company_roles_name.includes('developer')"
                    small
                    color="teal"
                    elevation="3"
                    class="text-capitalize white--text"
                    :disabled="process.form"
                    @click="form.progres = 100; progress()">
                    <v-icon small class="mr-1">mdi-check</v-icon>
                    Tandai Sudah Selesai
                  </v-btn>
                </div>
                <!-- JIKA SUDAH HABIS MASA AKTIF -->
                <div v-if="booking.company_project_is_active === '0'">
                  <span class="red--text font-weight-bold">
                    Langganan Habis
                  </span>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-title class="subtitle-2 pt-0">
            Aktifitas Pembangunan
          </v-card-title>
          <v-card-subtitle class="text-third line-text-first pt-2 caption">
            Anda bisa menambahkan aktifitas terkait proses pembangunan, seperti "Pondasi", "Pemasangan Perabotan" dan lain sebagainya.
          </v-card-subtitle>
          <v-card-text v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('teknik') || user.user_company_roles_name.includes('developer')">
            <v-btn v-if="booking.company_project_is_active === '1'"
              outlined
              :color="style.primary"
              class="text-capitalize mr-2"
              @click="reset()">
              <v-icon small class="mr-1">mdi-playlist-plus</v-icon>
              Tambah Aktifitas
            </v-btn>
          </v-card-text>
          <v-card-text class="py-0" v-if="!process.run && pagination.total_page > 0">
            <v-skeleton-loader
              class="ma-auto"
              :loading="process.run"
              transition="scale-transition"
              :tile="false"
              type="table">
              <v-simple-table>
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left pl-0">Nama Aktifitas</th>
                      <th class="text-left">Tanggal</th>
                      <th class="text-left">Keterangan</th>
                      <!-- <th class="text-right px-0">Aksi</th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr 
                      v-for="(item, index) in process.run ? 7 : list" 
                      :key="index">
                      <td class="text-second pl-0">
                        <v-list-item class="pa-0">
                          <v-list-item-avatar color="#E0E0E0" size="40" tile class="text-second rounded">
                            <v-img
                            :src="item.transaction_status_log_files.length > 0 ? item.transaction_status_log_files[0] : ''">
                          </v-img>
                          </v-list-item-avatar>

                          <v-list-item-content>
                            <v-list-item-title class="caption text-second mb-1">
                              {{ item.transaction_status_log_title }}
                            </v-list-item-title>
                            <v-list-item-subtitle class="text-third text-capitalize" style="font-size: 10px;">
                              <!-- Persentase Pembangunan {{ item.transaction_status_log_persen }} % -->
                              {{ item.transaction_status_log_category }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                      </td>
                      <td class="caption text-second">
                        {{ item.transaction_status_log_datetime | date }}
                      </td>
                      <td class="caption text-second">
                        {{ item.transaction_status_log_desc }}
                      </td>
                      <!-- <td class="orange--text text-right px-0">
                        <v-btn
                          small
                          outlined
                          color="orange"
                          min-width="30"
                          class="text-capitalize orange--text mx-1 px-0">
                          <v-icon small>mdi-pencil-outline</v-icon>
                        </v-btn>
                        <v-btn
                          small
                          outlined
                          color="red"
                          min-width="30"
                          class="text-capitalize red--text mx-1 px-0"
                          to="/project/unit/transaction">
                          <v-icon small>mdi-trash-can-outline</v-icon>
                        </v-btn>
                      </td> -->
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-skeleton-loader>
            <!-- <v-row justify="center" align="center" v-if="!process.run && pagination.total_page < 1">
              <v-col cols="12" class="d-flex align-center my-12">
                <v-img 
                  class="my-12"
                  contain
                  width="200"
                  height="200"
                  :src="require('../../assets/404/404.svg')">
                </v-img>
              </v-col>
            </v-row> -->
            <v-divider style="margin-top:3px;"/>
          </v-card-text>
          <v-card-text>
            <v-row justify="end" align="center" v-if="pagination.total_page > 1">
              <v-col cols="12" md="2" class="d-flex align-center justify-end">
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === 1"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 mr-3"
                  @click="selected.pagination = 1">
                  <v-icon>mdi-chevron-double-left</v-icon>
                </v-btn>
                <v-btn
                  color="#263238"
                  :disabled="pagination.current < 2"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  @click="selected.pagination = selected.pagination-1">
                  <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                <div class="mx-5" style="width: 75px;">
                  <v-autocomplete
                    v-model="selected.pagination"
                    :items="pagination.detail"
                    color="#263238"
                    auto-select-first
                    outlined
                    dense
                    single-line
                    hide-details
                    hide-selected>
                    <template v-slot:selection="{ item }">
                      {{ item }}
                    </template>
                  </v-autocomplete>
                </div>
                <v-btn
                  color="#263238"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0"
                  :disabled="pagination.current >= pagination.total_page"
                  @click="selected.pagination = selected.pagination+1">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
                <v-btn
                  :color="style.primary"
                  :disabled="pagination.current === pagination.total_page"
                  elevation="3"
                  min-width="36"
                  class="text-capitalize white--text px-0 ml-3"
                  @click="selected.pagination = pagination.total_page">
                  <v-icon>mdi-chevron-double-right</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  import ImageInput from "../../components/ImageInput.vue";
  export default {
    data () {
      return {
        selected: {
          pagination: 1
        },
        dialog: {
          form: false,
          success: false
        },
        images: false,
        list: [],
        pagination: {},
        form: {
          transaction_id: '',
          progres: 0,
          status: '',
          // persen: 0,
          files: []
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      ImageInput
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'form.progres': function(val) {
        this.form.progres = this.form.progres > 100 ? 100 : this.form.progres
      },
      images: {
        handler: function () {
          if (this.images) {
            this.form.files.push(this.images.url)
          }
        },
        deep: true
      },
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    props: [
      'booking'
    ],
    mounted () {
      this.fetch()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 7,
          transaction_id: this.$route.query.transaction
        }

        await get(`auth/transaction/development/detail`, { params })
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false
            this.form.progres = res.data.progress
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      fixedNumber(value) {
        return Number.parseFloat(value).toFixed(0)
      },
      reset() {
        this.dialog.form = !this.dialog.form ? true : false

        this.form = {
          transaction_id: this.$route.query.transaction,
          progres: 0,
          status: '',
          // persen: 0,
          files: []
        }

        this.process.form = false

        this.error.message = ''
      },
      remove(index) {
        this.form.files.splice(index, 1)
      },
      async progress() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/transaction/development/update-progress`, {
          data: {
            transaction_id: this.$route.query.transaction,
            progress: this.form.progres
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.process.form = false
            this.dialog.success = true
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async save() {
        this.error.message = ''
        
        let forms = Object.assign({}, this.form)
        forms.files = JSON.stringify(forms.files)

        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await post(`auth/transaction/development/update-status`, {
            data: forms
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.error.message = res.msg
            }
          })
        }
      }
    }
  }
</script>


<style lang="scss">
.sa {
  width: 140px;
  height: 140px;
  padding: 26px;
  background-color: #fff;
  &-success {
    border-radius: 50%;
    border: 4px solid var(--color-primary);
    box-sizing: content-box;
    height: 80px;
    padding: 0;
    position: relative;
    background-color: #fff;
    width: 80px;
    &:after, &:before {
      background: #fff;
      content: '';
      height: 120px;
      position: absolute;
      transform: rotate(45deg);
      width: 60px;
    }
    &:before {
      border-radius: 40px 0 0 40px;
      width: 26px;
      height: 80px;
      top: -17px;
      left: 5px;
      transform-origin: 60px 60px;
      transform: rotate(-45deg);
    }
    &:after {
      border-radius: 0 120px 120px 0;
      left: 30px;
      top: -11px;
      transform-origin: 0 60px;
      transform: rotate(-45deg);
      animation: rotatePlaceholder 4.25s ease-in;
    }
    &-placeholder {
      border-radius: 50%;
      border: 4px solid rgb(230 246 254 / 75%);
      box-sizing: content-box;
      height: 80px;
      left: -4px;
      position: absolute;
      top: -4px;
      width: 80px;
      z-index: 2;
    }
    &-fix {
      background-color: #fff;
      height: 90px;
      left: 28px;
      position: absolute;
      top: 8px;
      transform: rotate(-45deg);
      width: 5px;
      z-index: 1;
    }
    &-tip, &-long {
      background-color: var(--color-primary);
      border-radius: 2px;
      height: 5px;
      position: absolute;
      z-index: 2;
    }
    &-tip {
      left: 14px;
      top: 46px;
      transform: rotate(45deg);
      width: 25px;
      animation: animateSuccessTip .75s;
    }
    &-long {
      right: 8px;
      top: 38px;
      transform: rotate(-45deg);
      width: 47px;
      animation: animateSuccessLong .75s;
    }
  }
}
@keyframes animateSuccessTip {
  0%, 54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessLong {
  0%, 65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0%, 5% {
    transform: rotate(-45deg);
  }
  100%, 12% {
    transform: rotate(-405deg);
  }
}
</style>